module.exports = __webpack_public_path__ + "img/frontiertrends.6727c442.jpg";